const React = require('react');
const Spinner = require('./spinner.jsx');
const ErrorMessage = require('./error_message.jsx');

class Loading extends React.Component {
  render() {
    if (!this.props.loaded) { return <Spinner size={this.props.size} color={this.props.color} />; }
    if (this.props.hasError) { return <ErrorMessage message={this.props.errorMessage} />; }

    return <div className="loaded-component">{this.props.children}</div>;
  }
}

module.exports = Loading;



// WEBPACK FOOTER //
// ./javascripts/components/shared/loading.jsx